export const startLoadingApplication = () => dispatch => dispatch({ type: 'START_LOADING_APPLICATION' });

export const stopLoadingApplication = () => dispatch => dispatch({ type: 'STOP_LOADING_APPLICATION' });
